export default __webpack_public_path__ + "static/media/Close.70b26f9a.svg";